import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false, requireAuth = true }) => {
  const { user, loading, userStatus, showPendingPopup, showBlockedPopup } = useAuth();
  const location = useLocation();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  // Check if user is authenticated
  if (requireAuth && !user) {
    // Redirect to login page, saving the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check user status - if user is blocked or pending, don't render children
  if (user && (userStatus === 'blocked' || userStatus === 'pending')) {
    // The UserStatusHandler component will show the appropriate popup
    // Don't render the protected content
    return null;
  }

  // Check if admin access is required
  if (requireAdmin && (!user || (!user.isAdmin && !user.is_admin))) {
    // Redirect to unauthorized page or show access denied
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        padding: '20px'
      }}>
        <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>Access Denied</h1>
        <p style={{ color: '#666', marginBottom: '20px' }}>
          You need administrator privileges to access this page.
        </p>
        <button
          onClick={() => window.history.back()}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Go Back
        </button>
      </div>
    );
  }

  // User is authenticated and has required permissions
  return children;
};

export default ProtectedRoute; 